import React, { createContext, useContext, useState } from "react";
import { ISettingsContext, IGeneralSettings, INotificationSettings, ISecuritySettings } from "../exports/interfaces";

const SettingsContext = createContext<ISettingsContext>({
  generalSettings: null,
  setGeneralSettings: () => null,
  notificationSettings: null,
  setNotificationSettings: () => null,
  securitySettings: null,
  setSecuritySettings: () => null,
});

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const [generalSettings, setGeneralSettings] = useState<IGeneralSettings | null>(null);
  const [notificationSettings, setNotificationSettings] = useState<INotificationSettings | null>(null);
  const [securitySettings, setSecuritySettings] = useState<ISecuritySettings | null>(null);

  return (
    <SettingsContext.Provider
      value={{
        generalSettings,
        setGeneralSettings,
        notificationSettings,
        setNotificationSettings,
        securitySettings,
        setSecuritySettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};
